import { useMutation } from "react-query";
import HttpClient from "../../httpClient";
import authManagerInstance from "../../auth";

const validateToken = async ({ token, dateOfBirth }) => {
    try {
        const res = await HttpClient.memberLogin.post("/verify_login_link", {
            token,
            date_of_birth: dateOfBirth,
        });
        return res.data;
    } catch (error) {
        if (error.response) {
            throw error.response.data.message || "Unable to verify login link";
        } else {
            throw error;
        }
    }
};

const useValidateToken = (setErrorMessage) => {
    const { mutateAsync: validateTokenAsync, isError, isLoading } = useMutation(
        ({ token, dateOfBirth }) => validateToken({ token, dateOfBirth }),
        {
            onError: (error) => {
                if (setErrorMessage) {
                    setErrorMessage(error);
                }
            },
            onSuccess: (data) => {
                authManagerInstance.setUser(data);
            },
        }
    );
    return { validateToken: validateTokenAsync, isError, isLoading };
}
    
export default useValidateToken;
